import ScheduleInfoValidationSchema from '../validationschema/ScheduleInfoValidationSchema'

function useAddScheduleDetailsValidationSchema() {
    return ScheduleInfoValidationSchema()
}
export default useAddScheduleDetailsValidationSchema